// import {ListViewProvider, useListView} from '../core/ListViewProvider'
// import {QueryRequestProvider} from '../core/QueryRequestProvider'
// import {QueryResponseProvider, useQueryResponseData} from '../core/QueryResponseProvider'
// import {UsersListHeader} from '../components/header/UsersListHeader'
// import {UsersTable} from '../table/UsersTable'
// import {UserEditModal} from '../form-edit-modal/CoomonEditModal'
// import {KTCard, allCategory} from '../../../../../../_metronic/helpers'
// import {roleColumns} from './_columns'
// import {initialQueryState} from '../../../../../../_metronic/helpers'
// import {useEffect, useMemo, useState} from 'react'
// import {useQuery} from 'react-query'
// import {getUserById} from '../core/_requests'
// import {useQueryRequest} from '../core/QueryRequestProvider'
// import {MixedWidget1} from '../../../../../../_metronic/partials/widgets'
// import {useAuth} from '../../../../auth'

// const QualityList = () => {
//   const {isFranchise, isPartner, isSupplyChainManager, isFacilityManager, auth}: any = useAuth()

//   const {data} = useQuery(
//     // `users?page=0&size=100&type=PICKUP_POINT`,
//     // () => getUserById('', 'users?page=0&size=100&type=PICKUP_POINT'),
//     `users?type=PICKUP_POINT&facilityType=COLLECTION_TYPE%2CMRF%2CAGGREGATOR%2CDIVERSION_FACILITY`,
//     () => getUserById('', 'users?type=PICKUP_POINT&facilityType=COLLECTION_TYPE%2CMRF%2CAGGREGATOR%2CDIVERSION_FACILITY'),
//     {
//       enabled: isFranchise || isSupplyChainManager,
//       cacheTime: 0,
//       onError: (err) => {
//         console.warn(err)
//       },
//     }
//   )
//   const {updateState} = useQueryRequest()

//   const [categoriesList, setCategoriesList] = useState([{label: 'Select one', value: ''}])
//   useEffect(() => {
//     if (data && data?.length) {
//       let dropdownData: any = []
//       data.map((eachData) => {
//         return dropdownData.push({label: eachData?.personalDetails?.name, value: eachData.id})
//       })
//       setCategoriesList(dropdownData)
//       updateState({
//         enabled: true,
//         initialApi: `pickupPoints/stock/${dropdownData[0].value}`,
//         ...initialQueryState,
//       })
//     }
//   }, [data])

//   useEffect(() => {
//     if (isFacilityManager) {
//       updateState({
//         enabled: true,
//         initialApi: `pickupPoints/stock/${auth?.data?.pickuppointid}`,
//         ...initialQueryState,
//       })
//     }
//   }, [isFacilityManager])

//   const searchElements = [
//     {
//       type: 'select',
//       queryType: 'price',
//       value: 'select',
//       options: isFacilityManager
//         ? [
//             {label: 'Select one', value: ''},
//             {value: auth?.data?.pickuppointid, label: auth?.data?.pickuppointName},
//           ]
//         : categoriesList,
//       label: 'Select a facility',
//     },
//   ]

//   return (
//     <KTCard>
//       <UsersListHeader showDownload searchElements={searchElements} placeholder='Search' />
//       {/* <UsersTable columnProps={roleColumns(isFranchise)} /> */}

//       <div style={{
//         display: 'flex',
//         gap: '16px',
//         padding: '20px',
//         justifyContent: 'center',
//         marginBottom:"50px"
//       }}>
//         <div style={{
//           backgroundColor: 'white',
//           borderRadius: '8px',
//           boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
//           padding: '20px',
//           minHeight: '150px',
//           width: '250px'
//         }}>
//           {/* Card 1 - Empty */}
//         </div>

//         <div style={{
//           backgroundColor: 'white',
//           borderRadius: '8px',
//           boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
//           padding: '20px',
//           minHeight: '150px',
//           width: '250px'
//         }}>
//           {/* Card 2 - Empty */}
//         </div>

//         <div style={{
//           backgroundColor: 'white',
//           borderRadius: '8px',
//           boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
//           padding: '20px',
//           minHeight: '150px',
//           width: '250px'
//         }}>
//           {/* Card 3 - Empty */}
//         </div>

//         <div style={{
//           backgroundColor: 'white',
//           borderRadius: '8px',
//           boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
//           padding: '20px',
//           minHeight: '150px',
//           width: '250px'
//         }}>
//           {/* Card 4 - Empty */}
//         </div>
//       </div>

//       <div className='row g-5 g-xl-8'>
//         {/* begin::Col */}
//         {/* {test.map((eachTest, eachIndex) => (
//           <div className='col-xl-3' key={eachIndex + 1 + ''}>
//             <MixedWidget1
//               className='card-xl-stretch mb-xl-8'
//               color='primary'
//               data={eachTest}
//               bg_color={configColor_one[eachIndex % configColor_one?.length]}
//             />
//           </div>
//         ))} */}
//       </div>
//       {<UserEditModal formName='LeaderBoardForm' />}
//     </KTCard>
//   )
// }

// const StockWrapper = () => (
//   // <QueryRequestProvider initialValue={{enabled: false}}>
//   <QueryRequestProvider initialValue={{enabled: false}}>
//     <QueryResponseProvider>
//       <ListViewProvider>
//         <QualityList />
//       </ListViewProvider>
//     </QueryResponseProvider>
//   </QueryRequestProvider>
// )

// export {StockWrapper}




import { ListViewProvider, useListView } from '../core/ListViewProvider'
import { QueryRequestProvider } from '../core/QueryRequestProvider'
import { QueryResponseProvider, useQueryResponse, useQueryResponseData } from '../core/QueryResponseProvider'
import { UsersListHeader } from '../components/header/UsersListHeader'
import { UserEditModal } from '../form-edit-modal/CoomonEditModal'
import { KTCard, allCategory } from '../../../../../../_metronic/helpers'
import { initialQueryState } from '../../../../../../_metronic/helpers'
import { useEffect, useMemo, useState } from 'react'
import { useQuery } from 'react-query'
import { getUserById } from '../core/_requests'
import { useQueryRequest } from '../core/QueryRequestProvider'
import { useAuth } from '../../../../auth'
// import { MixedWidget10C } from '../../../../../../_metronic/partials/widgets/mixed/MixedWidget10C'
import { MixedWidgetForInventory } from '../../../../../../_metronic/partials/widgets/mixed/MixedWidgetTesr'

const QualityList = () => {
  const { isFranchise, isPartner, isSupplyChainManager, isFacilityManager, auth }: any = useAuth()

  const { data } = useQuery(
    `users?type=PICKUP_POINT&facilityType=COLLECTION_TYPE%2CMRF%2CAGGREGATOR%2CDIVERSION_FACILITY`,
    () => getUserById('', 'users?type=PICKUP_POINT&facilityType=COLLECTION_TYPE%2CMRF%2CAGGREGATOR%2CDIVERSION_FACILITY'),
    {
      enabled: isFranchise || isSupplyChainManager,
      cacheTime: 0,
      onError: (err) => {
        console.warn(err)
      },
    }
  )

  const { updateState } = useQueryRequest()
  const { response } = useQueryResponse()

  const [categoriesList, setCategoriesList] = useState([{ label: 'Select one', value: '' }])

  // Process inventory data for MixedWidget10C components
  const processInventoryData = (inventoryDetails: any[]) => {
    if (!inventoryDetails || !Array.isArray(inventoryDetails)) return []

    return inventoryDetails.map((item: any) => ({
      title: item.categoryName,
      subtitle: `${item.itemName || item.itemName}`,
      amount: `${item.quantity.toFixed(2)}`,
      chartData: item.dayWiseData,
      itemImage: item.itemImage,
      blockedQuantity: item.blockedQuantity
    }))
  }

  const inventoryWidgets = processInventoryData((response as any)?.data || [])

  useEffect(() => {
    if (data && data?.length) {
      let dropdownData: any = []
      data.map((eachData) => {
        return dropdownData.push({ label: eachData?.personalDetails?.name, value: eachData.id })
      })
      setCategoriesList(dropdownData)
      updateState({
        enabled: true,
        initialApi: `pickupPoints/stock/${dropdownData[0].value}`,
        ...initialQueryState,
      })
    }
  }, [data])

  useEffect(() => {
    if (isFacilityManager) {
      updateState({
        enabled: true,
        initialApi: `pickupPoints/stock/${auth?.data?.pickuppointid}`,
        ...initialQueryState,
      })
    }
  }, [isFacilityManager])

  const searchElements = [
    {
      type: 'select',
      queryType: 'price',
      value: 'select',
      options: isFacilityManager
        ? [
          { label: 'Select one', value: '' },
          { value: auth?.data?.pickuppointid, label: auth?.data?.pickuppointName },
        ]
        : categoriesList,
      label: 'Select Material Hub',
    },
  ]

  return (
    <KTCard>
      <UsersListHeader searchElements={searchElements} placeholder='Search' />


      {inventoryWidgets.length > 0 && (
        <div className="row" style={{ padding: '0 15px', marginTop: "10px" }}>
          {inventoryWidgets.map((widget, index) => (
            <div key={index} className="col-3 mb-4">
              <MixedWidgetForInventory
                className='card-xl-stretch'
                chartColor='info'
                chartHeight='150px'
                title={widget?.title?.[0]?.toUpperCase() + widget?.title?.slice(1)?.toLowerCase()}
                subtitle={widget.subtitle}
                amount={widget.amount}
                chartData={widget.chartData}
                itemImage={widget.itemImage}
                blockedQuantity={widget.blockedQuantity}
              />
            </div>
          ))}
        </div>
      )}

      <UserEditModal formName='LeaderBoardForm' />
    </KTCard>
  )
}

const StockWrapper = () => (
  <QueryRequestProvider initialValue={{ enabled: false }}>
    <QueryResponseProvider>
      <ListViewProvider>
        <QualityList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export { StockWrapper }